import { motion } from "framer-motion";
import { Reveal, stagger, item } from "@/lib/motion";
import { STAGES } from "@/data/site";

export const WhoWeWorkWith = () => (
  <section data-testid="who-we-work-with" className="section-pad bg-[#111111] text-white">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.25em] text-[#666666] mb-6 font-mono">Who we work with</p>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] max-w-3xl">
          Built for Where You&apos;re Growing From.
        </h2>
      </Reveal>

      <motion.div
        variants={stagger}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-60px" }}
        className="mt-16 grid grid-cols-1 md:grid-cols-3 border-t border-[#333333]"
      >
        {STAGES.map((s, i) => (
          <motion.div
            key={s.stage}
            variants={item}
            className={`py-10 md:pr-10 ${i !== 0 ? "md:pl-10" : ""} ${
              i !== STAGES.length - 1 ? "md:border-r border-[#333333] border-b md:border-b-0" : ""
            }`}
          >
            <span className="font-mono text-xs text-[#666666]">0{i + 1}</span>
            <h3 className="mt-4 font-serif text-3xl md:text-[2rem] leading-tight text-white">{s.stage}</h3>
            <p className="mt-6 text-[#999999] italic leading-relaxed">&ldquo;{s.challenge}&rdquo;</p>
            <div className="mt-6 w-10 h-px bg-[#666666]" />
            <p className="mt-6 text-[#E0E0E0] leading-relaxed">{s.delivers}</p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  </section>
);
